import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';
import { withRouter } from 'react-router'

import LanguageContext from '../../context/LangContext';

const Container = styled.form`
  position: relative;
  width: 30%;
  margin: 0 30px 0 60px;
  display: flex;
  background: rgba(0, 0, 0, 0.2);
  &.bigger {
    width: 52%;
  }
  @media (max-width: 980px) {
    width: 30%;
  }
  @media (max-width: 789px) {
    width: 38%;
  }
  input {
    border: 0;
    height: 76px;
    padding: 0 0 0 20px;
    width: 80%;
    background: none;
    box-sizing: border-box;
    font: italic bold 20px 'Times new roman';
    color: #D2AE82;
  }
  button {
    background: none;
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    padding: 0;
    i {
      background: url(/images/streamline-icon-search-1@48x48@2x.png) no-repeat center;
      background-size: contain;
      width: 24px;
      height: 24px;
      display: block;
    }
  }
`

class Search extends Component {
  state = {
    redirect: false,
    term: ''
  }

  componentDidMount() {
    this.setState({term: this.props.match.params.search});
  }

  doSearch(event) {
    event.preventDefault();
    this.setState({redirect: true})
  }

  updateValue(event) {
    this.setState({ term: event.target.value })
  }
  
  render () {
    const { language } = this.context;
    let text = ''
    switch (language) {
      case 'pt-br':
        text = 'Digite sua busca';
        break;
      case 'en-us':
        text = 'Type your search';
        break;
      case 'es-es':
        text = 'Escriba su búsqueda';
        break;
      default:
    }
    return (
      <Container className={ [`search`].join(' ') } onSubmit={ (e) => { this.doSearch(e) } } >
        {
          (this.state.redirect && this.state.term) && (
            <Redirect to={ `/busca/${this.state.term}` } />
          )
        }
        <input type="text" onChange={ (e) => { this.updateValue(e) } } value={ this.state.term } placeholder={ text } />
        <button>
          <i></i>
        </button>
      </Container>
    )
  }
}

Search.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

Search.contextType = LanguageContext;

export default withRouter(Search);
